export default __webpack_public_path__ + "static/media/konfhub-icon-rotate.d75cd371.gif";